import React from "react";
import { useNavigate } from "react-router-dom";
import "./SunsetMadnessHomepage.css";

function SunsetMadnessHomepage({ pageData }) {
 const navigate = useNavigate();

 const organization = pageData?.organization || {};
 const page = pageData?.page || {};
 const content = page?.content || {};

 const organizationName = organization.name || "Sunset Madness";

 const logoImage =
  content.logo_image_url || "";

 const heroTitle =
  content.hero_title || organizationName;

 const heroSubtitle =
  content.hero_subtitle ||
  "Basketball Tournaments for Young Adults";

 const heroButtonLabel =
  content.hero_button_label || "REGISTER";

 const heroButtonLink =
  content.hero_button_link || "";

 const heroBackgroundImage =
  content.hero_background_image_url || "";

 const handleHeroClick = () => {
  const rawLink = String(heroButtonLink || "").trim();

  if (!rawLink) return;

  const isExternal =
   rawLink.startsWith("http://") ||
   rawLink.startsWith("https://");

  const looksLikeDomain =
   !rawLink.startsWith("/") &&
   rawLink.includes(".") &&
   !rawLink.startsWith("./") &&
   !rawLink.startsWith("../");

  if (isExternal) {
   window.open(
    rawLink,
    "_blank",
    "noopener,noreferrer"
   );
   return;
  }

  if (looksLikeDomain) {
   window.open(
    `https://${rawLink}`,
    "_blank",
    "noopener,noreferrer"
   );
   return;
  }

  navigate(
   rawLink.startsWith("/")
    ? rawLink
    : `/${rawLink}`
  );
 };

 return (
  <div className="sunsetMadnessHomepage">
   <section
    className="sunsetMadnessHomepage-hero"
    style={
     heroBackgroundImage
      ? {
       backgroundImage: `url(${heroBackgroundImage})`,
      }
      : undefined
    }
   >
    <div className="sunsetMadnessHomepage-overlay" />

    <div className="sunsetMadnessHomepage-content">
     {logoImage && (
      <img
       src={logoImage}
       alt={organizationName}
       className="sunsetMadnessHomepage-logo"
      />
     )}

     <h1>{heroTitle}</h1>

     {heroSubtitle && (
      <p>{heroSubtitle}</p>
     )}

     {heroButtonLink && (
      <button
       type="button"
       onClick={handleHeroClick}
      >
       {heroButtonLabel}
      </button>
     )}
    </div>
   </section>
  </div>
 );
}

export default SunsetMadnessHomepage;